module.exports = __webpack_public_path__ + "static/media/scene-toaster-2.c4342c52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scene-toaster-2.jpg
// module id = 294
// module chunks = 0